<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Chờ xác nhận</h2>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Chọn trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="4">
        </el-col>
        <el-col :span="2">
        </el-col>
        <el-col :span="6">
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            clearable
            class="input-seach"
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="table.pagination.per_page"
          :pager-count="table.pagination.count"
          :current-page="table.pagination.current_page"
          :total="table.pagination.total"
          @current-change="changeCurrentPage">
        </el-pagination>
        <div>
          Hiển thị tới Chờ xác nhận <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Chờ xác nhận
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            label="Nội dung">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info" v-if="scope.row.content">
                  <span>Họ và tên: {{ scope.row.content.name }}</span>
                  <span>Ngày sinh: {{ scope.row.content.birthday }}</span>
                  <span>Số điện thoại: {{ scope.row.content.phone }}</span>
                  <span>Email: {{ scope.row.content.email }}</span>
                  <span>Trường tốt nghiệp gần nhất: {{ scope.row.content.school }}</span>
                  <span>Xét tuyển theo: {{ scope.row.content.admission }}</span>
                  <span>Hệ đào tạo: {{ scope.row.content.level }}</span>
                  <span>Chuyên ngành: {{ scope.row.content.facult }}</span>
                  <span>Hệ cam kết đào tạo: {{ scope.row.content.commit }}</span>
                  <span>Địa chỉ liên hệ: {{ scope.row.content.address }}</span>
                  <span>Địa điểm nộp hồ sơ và học tập: {{ scope.row.content.key_address_text }}</span>
                </div>
                <div class="courses-info" v-if="scope.row.userContent">
                  <span>Họ và tên: {{ scope.row.userContent.name }}</span>
                  <span>Ngày sinh: {{ scope.row.userContent.birthday }}</span>
                  <span>Số điện thoại: {{ scope.row.userContent.phone }}</span>
                  <span>Email: {{ scope.row.userContent.email }}</span>
                  <span>Hệ đào tạo: {{ scope.row.userContent.level_name }}</span>
                  <span>Địa chỉ liên hệ: {{ scope.row.userContent.city_name }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền / Nguồn">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
              <p style="color: green">{{ scope.row.type_txt }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Nhân viên chờ xử lý"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.user_id_care_name }}</span>
                <span>{{ scope.row.user_id_care_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Hết hạn xác nhận"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info" v-if="scope.row.user_id_care">
                <span style="font-weight: bold">{{ scope.row.time_next_end }}</span>
                <el-progress :percentage="scope.row.time_next_100"></el-progress>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Xác nhận"
            header-align="center"
            width="180">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info-2" v-if="scope.row.user_id_care == accountInfo.id">
                  <el-button
                    :disable="!canSubmit"
                    :loading="!canSubmit"
                    type="success"
                    size="small"
                    @click="confirmHelpCare(scope.row)">Đồng ý
                  </el-button>

                  <el-button
                    :disable="!canSubmit"
                    :loading="!canSubmit"
                    type="danger"
                    size="small"
                    @click="cancelHelpCare(scope.row)">Hủy
                  </el-button>
                </div>
                <div class="module-action" style="padding-top: 10px">
                  <el-tooltip effect="dark" content="Lịch sử" placement="top" v-if='accountInfo.user_type == 1'>
                    <span @click="showLog(scope.row)">
                      <i class="fas fa-history"></i>
                    </span>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="Chi tiết" placement="top" v-if='scope.row.type == 3'>
                    <span @click="showTeacherUpgradeDialog(scope.row)">
                      <i class="fas fa-list-ul"></i>
                    </span>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="Xóa" placement="top" v-if="accountInfo.user_type == 1 && scope.row.user_id_care == 0">
                    <span @click="confirmDeleteModel(scope.row)">
                      <i class="far fa-trash-alt icon-delete"></i>
                    </span>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>

    <el-dialog
      :close-on-click-modal="false"
      :title="'Lịch sử chia tư vấn tự động'"
      :visible.sync="classUser.dialogVisibleLog"
      width="45%">
      <el-tabs v-model="activeName">
        <el-tab-pane label="Lịch sử chia tư vấn tự động" name="first">
          <div class="log-class-user" v-if="classUser.modelData.logs">
            <div
              class="item"
              :key="index_1"
              v-for="(item, index_1) in classUser.modelData.logs">
              <strong>{{ item.text }}</strong>
              <div>
                <span class="time">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classUser.dialogVisibleLog = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>

    <!-- preview dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Thông tin đăng ký'"
      :visible.sync="teacherUpgradeDialogVisible"
      top="20px"
      width="85%">
      <div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form label-position="top" :model="userInfo" ref="searchQuestionsDialog" @submit.native.prevent>

              <el-card class="box-card">
                <!-- column 1 -->
                <el-col :span="12">
                  <el-form-item label="Họ và tên" class="form-item">
                      <el-input v-model="userInfo.name" placeholder="Họ và tên" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>

                  <el-form-item label="Ngày sinh" class="orm-item input-daterange">
                    <el-date-picker
                      v-model="userInfo.birthday"
                      type="date"
                      :editable="false"
                      :clearable="false"
                      prefix-icon=""
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Ngày sinh"
                      :disabled="true">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="Công việc hiện tại" class="form-item">
                    <el-input v-model="userInfo.current_job" placeholder="Công việc hiện tại" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>

                  <el-form-item label="Ảnh CMND/CCCD mặt trước">
                    <img width="250px" height="250px" style="object-fit: contain;" v-for="url in userInfo.IDCardFrontSideImageUrl" :key="url" :src="url" alt="">
                  </el-form-item>

                </el-col>

                <!-- column 2 -->
                <el-col :span="12">
                  <el-form-item label="Email" class="form-item">
                    <el-input v-model="userInfo.email" placeholder="Email" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>

                  <el-form-item label="Danh xưng" class="form-item">
                    <el-radio v-model="userInfo.sex" label="1" :disabled="true">Thầy</el-radio>
                    <el-radio v-model="userInfo.sex" label="0" :disabled="true">Cô</el-radio>
                  </el-form-item>

                  <el-form-item label="Nơi sinh sống" class="form-item">
                    <el-select v-model="userInfo.city_code" filterable placeholder="" class="input-select" :disabled="true">
                        <el-option
                            v-for="item in lists.listCity"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Ảnh CMND/CCCD mặt sau">
                    <img width="250px" height="250px" style="object-fit: contain;" v-for="url in userInfo.IDCardBackSideImageUrl" :key="url" :src="url" alt="">
                  </el-form-item>

                </el-col>
              </el-card>
              <br>

              <el-card class="box-card">
                <el-col :span="12">
                  <el-form-item label="Phương thức thanh toán" class="form-item">
                      <el-select v-model="userInfo.paymentMethod" filterable placeholder="Phương thức thanh toán" class="input-select" :disabled="true">
                          <el-option
                          v-for="item in lists.bankCard"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                          </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item label="Số tài khoản">
                      <el-input v-model="userInfo.bankAccountNumber" placeholder="Số tài khoản" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>

                  <el-form-item label="Chi nhánh">
                      <el-input v-model="userInfo.bankBranchName" placeholder="Nhập tên chi nhánh" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="Tên tài khoản">
                      <el-input v-model="userInfo.bankAccountName" placeholder="ví dụ: Nguyễn Văn A" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>

                  <el-form-item label="Ngân hàng" class="form-item">
                      <el-select v-model="userInfo.bank" filterable placeholder="Chọn Ngân hàng" class="input-select" :disabled="true">
                          <el-option
                          v-for="item in lists.banks"
                          :key="item.code"
                          :label="'(' + item.shortName + ') ' + item.name"
                          :value="item.code">
                          </el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
              </el-card>
              <br>

              <el-card class="box-card">

                <el-col :span="12">
                  <el-form-item label="Hình ảnh cá nhân">
                    <img width="250px" height="250px" style="object-fit: contain;" v-for="url in userInfo.profileImageUrl" :key="url" :src="url" alt="">
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="Giới thiệu" class="form-item">
                      <el-input
                          type="textarea"
                          placeholder="Thu hút hoc viên nhiều hơn bằng những thông tin nổi bật nhất về kinh nghiệm giảng dạy của bản thân"
                          v-model="userInfo.introduceText"
                          :autosize="{ minRows: 2, maxRows: 5}"
                          show-word-limit
                          :disabled="true"
                      >
                      </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label="Trường Đại học/Cao đẳng">
                      <el-input v-model="userInfo.school" placeholder="Trường Đại học/Cao đẳng đã tốt nghiệp" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label="Ngành">
                      <el-input v-model="userInfo.major" placeholder="Ngành theo học" class="input-seach" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item label="Năm tốt nghiệp" class="form-item">
                      <el-date-picker v-model="userInfo.graduationYear" type="year" :disabled="true"></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="Bằng cấp cao nhất">
                    <img width="250px" height="250px" style="object-fit: contain;" v-for="url in userInfo.mainCerfiticateUrl" :key="url" :src="url" alt="">
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="Bằng cấp/ chứng chỉ khác">
                    <img width="250px" height="250px" style="object-fit: contain;" v-for="url in userInfo.otherCerfiticateList" :key="url" :src="url" alt="">
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="Số năm kinh nghiệm giảng dạy">
                      <el-input-number v-model="userInfo.teachingExperience" :min="0" :max="100" :disabled="true"></el-input-number>
                  </el-form-item>
                </el-col>

              </el-card>
              <br>

              <el-col :span="12">
                <el-form-item label="Lý do" class="form-item">
                    <el-input
                        type="textarea"
                        placeholder="Nhập lý do trong trường hợp từ chối"
                        v-model="userInfo.refuseReason"
                        :autosize="{ minRows: 5, maxRows: 10}"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
              </el-col>

            </el-form>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" :disable="!canSubmit" :loading="!canSubmit"
          @click="confirmEvent()" size="small" plain><i class="el-icon-check"></i> Chấp nhận</el-button>
        <el-button type="danger" :disable="!canSubmit" :loading="!canSubmit"
          @click="refuseEvent()" size="small" plain>Từ chối</el-button>
        <el-button @click="teacherUpgradeDialogVisible = false" size="small" plain type="info">Cancel</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  inject: ['$validator'],
  name: 'CategoryBlog',
  metaInfo () {
    return {
      title: 'Chờ xác nhận'
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      activeName: 'first',
      loading: false,
      searching: false,
      canSubmit: true,
      teacherUpgradeDialogVisible: false,
      filter: {
        q: '',
        user_id_care_confirm: 0,
        page: 1,
        limit: 12,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCity: [],
        bankCard: [
            {key: 1, value: 'Thẻ ATM nội địa'},
            {key: 2, value: 'Thẻ tín dụng/Ghi nợ'},
        ],
        banks: [],
      },
      table: {
        database: [],
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      },
      classUser: {
        dialogVisible: false,
        dialogVisibleLog: false,
        dialogVisibleOpen: false,
        modelData: {},
        modelPush: {
          money: 1000000
        },
        courses_default: {}
      },
      userInfo: {
        name: '',
        // sex: '1',
        IDCardFrontSideImageUrl: [],
        IDCardBackSideImageUrl: [],
      },
      selectedUserId: '',
    }
  },
  mounted () {
    this.configBreadcrumb();
    this.fetchDatabaseModel();
    this.getBanks();
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'help-cares-index', text: 'Chờ xác nhận' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('help-cares', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      // let routeData = this.$router.resolve({name: 'help-cares-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'help-cares-show', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('help-cares/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('help-cares/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },

    // Show log:
    showLog (model) {
      this.classUser.modelData = model
      this.classUser.dialogVisibleLog = true
    },

    // Show teacher upgrade dialog:
    showTeacherUpgradeDialog (model) {
      this.selectedUserId = model.user_id;
      this.fetchUserRequestedData(this.selectedUserId);
      this.teacherUpgradeDialogVisible = true;
    },

    fetchUserRequestedData(userId){
      axios.get('users/' + userId, {params: {}}).then(response => {
        switch (response.code) {
          case 200:
            this.userInfo = response.data;
            console.log(response.data);
            if (response.data.expanded_info) {
                this.userInfo.paymentMethod = response.data.expanded_info.paymentMethod;
                this.userInfo.bankAccountName = response.data.expanded_info.bankAccountName;
                this.userInfo.bankAccountNumber = response.data.expanded_info.bankAccountNumber;
                this.userInfo.bank = response.data.expanded_info.bank;
                this.userInfo.bankBranchName = response.data.expanded_info.bankBranchName;
                this.userInfo.introduceText = response.data.expanded_info.introduceText;
                this.userInfo.school = response.data.expanded_info.school;
                this.userInfo.major = response.data.expanded_info.major;
                this.userInfo.graduationYear = response.data.expanded_info.graduationYear;
                this.userInfo.teachingExperience = response.data.expanded_info.teachingExperience;

                if (response.data.expanded_info.IDCardFrontSideImageUrl) {
                    this.userInfo.IDCardFrontSideImageUrl = [];
                    this.userInfo.IDCardFrontSideImageUrl.push(response.data.expanded_info.IDCardFrontSideImageUrl);
                }

                if (response.data.expanded_info.IDCardBackSideImageUrl) {
                    this.userInfo.IDCardBackSideImageUrl = [];
                    this.userInfo.IDCardBackSideImageUrl.push(response.data.expanded_info.IDCardBackSideImageUrl);
                }

                if (response.data.expanded_info.profileImageUrl) {
                    this.userInfo.profileImageUrl = [];
                    this.userInfo.profileImageUrl.push(response.data.expanded_info.profileImageUrl);
                }

                // if (response.data.expanded_info.introduceVideoUrl) {
                //     this.userInfo.introduceVideoUrl = response.data.expanded_info.introduceVideoUrl;
                //     this.introduceVideoUrl.push({"name":"intro video", "url":this.image_url + response.data.expanded_info.introduceVideoUrl});
                // }

                if (response.data.expanded_info.mainCerfiticateUrl) {
                    this.userInfo.mainCerfiticateUrl = [];
                    this.userInfo.mainCerfiticateUrl.push(response.data.expanded_info.mainCerfiticateUrl);
                }

                if (response.data.expanded_info.otherCerfiticateList) {
                    this.userInfo.otherCerfiticateList = response.data.expanded_info.otherCerfiticateList;
                }
            }
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    getBanks() {
        // Tạo URL để truy vấn API
        const url = 'https://api.vietqr.io/v2/banks';

        // Gửi yêu cầu GET
        fetch(url).then((response) => response.json()).then((data) => {
            // Lưu danh sách ngân hàng vào biến `banks`
            this.lists.banks = data.data;
        });
    },

    refuseEvent() {
      if(!this.userInfo.refuseReason){
        this.$message.error('Vui lòng nhập lý do từ chối');
      } else {
        this.$confirm('Xác nhận từ chối yêu cầu nâng cấp tài khoản', 'Warning', {
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Hủy',
          type: 'warning'
        }).then(() => {
          this.cancelAccountUpdradeAction(this.selectedUserId)
        }).catch(() => {

        })
      }
    },

    cancelAccountUpdradeAction (userId) {
      this.canSubmit = false
      axios.post('user/cancelUpgradeRequest/' + userId).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Hủy thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    confirmEvent() {
      this.$confirm('Xác nhận phê duyệt yêu cầu nâng cấp tài khoản', 'Warning', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.confirmAccountUpdradeAction(this.selectedUserId)
      }).catch(() => {

      })
    },

    confirmAccountUpdradeAction (userId) {
      this.canSubmit = false
      axios.post('user/confirmUpgradeRequest/' + userId).then(response => {
        this.canSubmit = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Phê duyệt thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    cancelHelpCare (model) {
      this.$confirm('Xác nhận hủy hỗ trợ: ' + model.name, 'Warning', {
        confirmButtonText: 'Không hỗ trợ',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.cancelHelpCareAction(model)
      }).catch(() => {

      })
    },
    cancelHelpCareAction (model) {
      axios.post('help-cares/cancel/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Hủy thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    confirmHelpCare (model) {
      this.$confirm('Xác nhận hỗ trợ: ' + model.name, 'Warning', {
        confirmButtonText: 'Hỗ trợ',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.confirmHelpCareAction(model)
      }).catch(() => {

      })
    },
    confirmHelpCareAction (model) {
      axios.post('help-cares/confirm/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xác nhận thành công thành công',
              type: 'success'
            })
            this.$router.push({name: 'help-cares-index'})
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}

.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}

.courses-info-2 {
  display: flex;
  flex-direction: row;
}

.log-class-user .item {
  margin-bottom: 10px;
}
.log-class-user .time {
  color: #7d7d7d;
}
</style>



// WEBPACK FOOTER //
// src/components/help-care-confirms/Index.vue